<template>
    <p class="p3">
        <slot />
    </p>
</template>
